/**
 * ExportErrorListener.tsx
 * Composant qui écoute les erreurs d'export et les affiche via ToastProvider
 */
import { useEffect } from 'react';
import { useToast } from './ToastProvider';
import { exportErrorEmitter, type ExportErrorEvent } from '../../../services/ExportErrorEmitter';

/**
 * Composant qui écoute les erreurs d'export et les affiche via ToastProvider
 */
export function ExportErrorListener(): null {
  const { addToast } = useToast();

  useEffect(() => {
    const handleExportError = (event: ExportErrorEvent) => {
      addToast({
        type: event.type,
        message: event.message,
        duration: event.duration || 5000,
      });
    };

    exportErrorEmitter.onExportError(handleExportError);

    return () => {
      exportErrorEmitter.offExportError(handleExportError);
    };
  }, [addToast]);

  return null;
}
